module.exports = __webpack_public_path__ + "media/images/undraw_real_time_sync-b04b197db46bcd7c443c0ad7e2ae39de.svg";